import httpClient from "./httpClient";

const base = "/class-teacher-signatures";

export function listClassTeacherSignatures() {
  return httpClient.get(base).then((res) => res.data.data);
}

export function saveClassTeacherSignature(classConfigId, staffId, file) {
  const formData = new FormData();
  formData.append("classConfigId", classConfigId);
  formData.append("staffId", staffId);
  formData.append("file", file);
  return httpClient.post(base, formData, { headers: { "Content-Type": "multipart/form-data" } }).then((res) => res.data.data);
}

export function deleteClassTeacherSignature(signatureId) {
  return httpClient.delete(`${base}/${signatureId}`).then((res) => res.data);
}
